import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./details.css";
import {
  checkStatus,
  defaultOptions,
  getLocationOrigin,
  parseJSON,
} from "../../../../../../services";

function IconSearch() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}

function IconSpinner() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="aad-spin">
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  );
}

function IconMapPin() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function IconMapPinArea() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function IconCalendar() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

function IconUser() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

function IconTag() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  );
}

function IconTrophy() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16" />
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2z" />
    </svg>
  );
}

function IconPinEntry() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function IconInfo() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  );
}

class AddAlbumBasicDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      albumName: "",
      description: "",
      albumType: "",
      albumTypes: [],

      activeTab: "event",

      searchQuery: "",
      filteredEvents: [],
      selectedEvent: null,
      selectedEventData: null,
      searching: false,

      cityQuery: "",
      filteredCities: [],
      selectedCity: null,
      selectedCityData: null,
      citySearching: false,

      venueQuery: "",
      filteredVenues: [],
      selectedVenue: null,
      selectedVenueData: null,
      venueSearching: false,

      manualDate: "",
      loading: false,
    };

    this._searchTimer = null;
    this._citySearchTimer = null;
    this._venueSearchTimer = null;
  }

  componentDidMount() {
    /* Fetch Album Types */
    fetch(`${getLocationOrigin()}/gallery/get_albums_by_location/?page=1`, defaultOptions)
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => {
        this.setState({
          albumTypes: data && data.album_types ? data.album_types : [],
        });
      })
      .catch((err) => {
        console.error("Failed to fetch album types", err);
      });
  }

  componentWillUnmount() {
    clearTimeout(this._searchTimer);
    clearTimeout(this._citySearchTimer);
    clearTimeout(this._venueSearchTimer);
  }

  handleChange = (field, value) => {
    this.setState({ [field]: value });
  };

  handleTabSwitch = (tab) => {
    this.setState({
      activeTab: tab,
      searchQuery: "",
      filteredEvents: [],
      selectedEvent: null,
      selectedEventData: null,
      searching: false,
      cityQuery: "",
      filteredCities: [],
      selectedCity: null,
      selectedCityData: null,
      citySearching: false,
      venueQuery: "",
      filteredVenues: [],
      selectedVenue: null,
      selectedVenueData: null,
      venueSearching: false,
      manualDate: "",
    });
  };

  handleSearchChange = (value) => {
    this.setState({
      searchQuery: value,
      selectedEvent: null,
      selectedEventData: null,
      filteredEvents: [],
      searching: false,
    });

    if (!value || value.trim().length < 2) return;

    this.setState({ searching: true });

    clearTimeout(this._searchTimer);
    this._searchTimer = setTimeout(() => {
      fetch(
        `${getLocationOrigin()}/gallery/search_events/?search=${encodeURIComponent(value.trim())}`,
        defaultOptions
      )
        .then(checkStatus)
        .then(parseJSON)
        .then((data) => {
          this.setState({
            filteredEvents: data && data.results ? data.results : [],
            searching: false,
          });
        })
        .catch((err) => {
          console.error("Failed to search events", err);
          this.setState({ filteredEvents: [], searching: false });
        });
    }, 300);
  };

  handleSelectEvent = (event) => {
    this.setState({
      selectedEvent: event.id,
      selectedEventData: event,
      searchQuery: event.name,
      filteredEvents: [],
      searching: false,
    });
  };

  handleClearEvent = () => {
    this.setState({
      selectedEvent: null,
      selectedEventData: null,
      searchQuery: "",
      filteredEvents: [],
    });
  };

  handleCitySearchChange = (value) => {
    this.setState({
      cityQuery: value,
      selectedCity: null,
      selectedCityData: null,
      filteredCities: [],
      citySearching: false,
      selectedVenue: null,
      selectedVenueData: null,
      venueQuery: "",
      filteredVenues: [],
    });

    if (!value || value.trim().length < 2) return;

    this.setState({ citySearching: true });

    clearTimeout(this._citySearchTimer);
    this._citySearchTimer = setTimeout(() => {
      fetch(`${getLocationOrigin()}/gallery/search_locations/?search=${encodeURIComponent(value.trim())}`)
        .then((res) => {
          if (!res.ok) throw new Error("Search failed");
          return res.json();
        })
        .then((data) => {
          this.setState({
            filteredCities: data && data.locations ? data.locations : [],
            citySearching: false,
          });
        })
        .catch((err) => {
          console.error("Failed to search cities", err);
          this.setState({ filteredCities: [], citySearching: false });
        });
    }, 300);
  };

  handleSelectCity = (city) => {
    this.setState({
      selectedCity: city.id,
      selectedCityData: city,
      cityQuery: city.name,
      filteredCities: [],
      citySearching: false,
      selectedVenue: null,
      selectedVenueData: null,
      venueQuery: "",
      filteredVenues: [],
    });
  };

  handleClearCity = () => {
    this.setState({
      selectedCity: null,
      selectedCityData: null,
      cityQuery: "",
      filteredCities: [],
    });
  };

  handleVenueSearchChange = (value) => {
    this.setState({
      venueQuery: value,
      selectedVenue: null,
      selectedVenueData: null,
      filteredVenues: [],
      venueSearching: false,
      selectedCity: null,
      selectedCityData: null,
      cityQuery: "",
      filteredCities: [],
    });

    if (!value || value.trim().length < 2) return;

    this.setState({ venueSearching: true });

    clearTimeout(this._venueSearchTimer);
    this._venueSearchTimer = setTimeout(() => {
      fetch(`${getLocationOrigin()}/gallery/search_venues/?search=${encodeURIComponent(value.trim())}`)
        .then((res) => {
          if (!res.ok) throw new Error("Search failed");
          return res.json();
        })
        .then((data) => {
          this.setState({
            filteredVenues: data && data.venues ? data.venues : [],
            venueSearching: false,
          });
        })
        .catch((err) => {
          console.error("Failed to search venues", err);
          this.setState({ filteredVenues: [], venueSearching: false });
        });
    }, 300);
  };

  handleSelectVenue = (venue) => {
    this.setState({
      selectedVenue: venue.id,
      selectedVenueData: venue,
      venueQuery: venue.name,
      filteredVenues: [],
      venueSearching: false,
      selectedCity: null,
      selectedCityData: null,
      cityQuery: "",
      filteredCities: [],
    });

    if (venue.location_id) {
      this.setState({
        selectedCity: venue.location_id,
        selectedCityData: {
          id: venue.location_id,
          name: venue.city || venue.name,
          slug: "",
        },
        cityQuery: venue.city || venue.name,
      });
    }
  };

  handleClearVenue = () => {
    this.setState({
      selectedVenue: null,
      selectedVenueData: null,
      venueQuery: "",
      filteredVenues: [],
    });
  };

  isFormValid() {
    const { albumName, albumType, activeTab, selectedEvent, selectedCity } = this.state;

    if (!albumName || !albumType) return false;

    if (activeTab === "event") {
      return !!selectedEvent;
    }

    return !!selectedCity;
  }

  handleContinue = async () => {
    var self = this;
    var { albumName, description, albumType, activeTab, selectedEventData, selectedCity, selectedVenue, manualDate } = this.state;

    this.setState({ loading: true });

    try {
      var encodedName = encodeURIComponent(albumName);
      var createResponse = await fetch(
        `${getLocationOrigin()}/gallery/create_album/?name=${encodedName}`,
        defaultOptions
      )
        .then(checkStatus)
        .then(parseJSON);

      if (!createResponse || !createResponse.id) throw new Error("Album creation failed");

      var albumId = createResponse.id;
      var formData = new FormData();
      formData.append("album_id", albumId);
      formData.append("name", albumName);

      if (description) formData.append("description", description);
      if (albumType)   formData.append("album_type", albumType);

      if (activeTab === "event" && selectedEventData) {
        if (selectedEventData.start_date)   formData.append("organized_on", selectedEventData.start_date);
        if (selectedEventData.competition_id) formData.append("competition_id", selectedEventData.competition_id);
      } else if (activeTab === "location") {
        if (selectedCity) formData.append("location_id", selectedCity);
        if (selectedVenue) formData.append("venue_id", selectedVenue);
        if (manualDate) formData.append("organized_on", manualDate);
      }

      await fetch(`${getLocationOrigin()}/tournament/update_album/`, {
        method: "POST",
        body: formData,
        ...defaultOptions,
      })
        .then(checkStatus)
        .then(parseJSON);

      self.props.history.push(`/crud/gallery/add/photos/${albumId}`);
    } catch (error) {
      console.error(error);
      alert(error.message);
    } finally {
      self.setState({ loading: false });
    }
  };

  render() {
    var {
      albumName, description, albumType, albumTypes,
      activeTab,
      searchQuery, filteredEvents, selectedEvent, selectedEventData, searching,
      cityQuery, filteredCities, selectedCity, selectedCityData, citySearching,
      venueQuery, filteredVenues, selectedVenue, selectedVenueData, venueSearching,
      manualDate,
      loading,
    } = this.state;

    var showEventDropdown = searchQuery.length >= 2 && !selectedEvent;
    var showCityDropdown = cityQuery.length >= 2 && !selectedCity;
    var showVenueDropdown = venueQuery.length >= 2 && !selectedVenue;

    return (
      <div className="aad-container">
        <div className="aad-header">
          <Link to="/crud/gallery" className="aad-back-btn">←</Link>
          <div>
            <h1 className="aad-title">Add New Album</h1>
            <p className="aad-subtitle">Step 1 of 2: Basic Details</p>
          </div>
        </div>

        <div className="aad-card">
          <div className="aad-fields">
            <div className="aad-field">
              <label className="aad-label">Album Name *</label>
              <input
                type="text"
                className="aad-input"
                placeholder="Enter album name"
                value={albumName}
                onChange={(e) => this.handleChange("albumName", e.target.value)}
              />
            </div>

            <div className="aad-field">
              <label className="aad-label">Description</label>
              <textarea
                className="aad-textarea"
                placeholder="Enter album description"
                value={description}
                onChange={(e) => this.handleChange("description", e.target.value)}
              />
            </div>

            <div className="aad-field">
              <label className="aad-label">Album Type *</label>
              <div className="aad-select-wrapper">
                <select
                  className={"aad-select" + (!albumType ? " aad-select--placeholder" : "")}
                  value={albumType}
                  onChange={(e) => this.handleChange("albumType", e.target.value)}
                >
                  <option value="">Select album type</option>
                  {albumTypes.length > 0 ? (
                    albumTypes.map((type) => (
                      <option key={type.value} value={type.value}>{type.label}</option>
                    ))
                  ) : (
                    [
                      { value: "Tournaments", label: "Tournaments" },
                      { value: "Trainings",   label: "Trainings"   },
                      { value: "Events",      label: "Events"      },
                      { value: "Others",      label: "Others"      },
                    ].map((type) => (
                      <option key={type.value} value={type.value}>{type.label}</option>
                    ))
                  )}
                </select>
                <span className="aad-select-arrow">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </div>
            </div>

            <div className="aad-field">
              <label className="aad-label">Event / Location *</label>

              <div className="aad-tab-bar">
                <button
                  type="button"
                  className={"aad-tab-btn" + (activeTab === "event" ? " aad-tab-btn--active" : "")}
                  onClick={() => this.handleTabSwitch("event")}
                >
                  <span className="aad-tab-icon"><IconTrophy /></span>
                  Link an event
                  <span className="aad-tab-dot"></span>
                </button>
                <button
                  type="button"
                  className={"aad-tab-btn" + (activeTab === "location" ? " aad-tab-btn--active" : "")}
                  onClick={() => this.handleTabSwitch("location")}
                >
                  <span className="aad-tab-icon"><IconPinEntry /></span>
                  Select location
                  <span className="aad-tab-dot"></span>
                </button>
              </div>

              {activeTab === "event" && (
                <div className="aad-tab-panel">
                  <div className="aad-search-wrapper">
                    <span className="aad-search-icon">{searching ? <IconSpinner /> : <IconSearch />}</span>
                    <input
                      type="text"
                      className={"aad-input aad-input--search" + (selectedEvent ? " aad-input--selected" : "")}
                      placeholder="Search by event name or venue..."
                      value={searchQuery}
                      onChange={(e) => this.handleSearchChange(e.target.value)}
                      autoComplete="off"
                      readOnly={!!selectedEvent}
                    />
                    {selectedEvent && (
                      <button type="button" className="aad-search-clear" onClick={this.handleClearEvent} title="Clear selection">✕</button>
                    )}
                  </div>

                  {!searchQuery && !selectedEvent && (
                    <div className="aad-search-empty-state">
                      <div className="aad-search-empty-state-icon"><IconTrophy /></div>
                      <div className="aad-search-empty-state-text">Search for a tournament or event</div>
                      <div className="aad-search-empty-state-sub">Type at least 2 characters to get started</div>
                    </div>
                  )}

                  {showEventDropdown && (
                    <div className="aad-search-dropdown">
                      {searching ? (
                        <div className="aad-search-status">Searching...</div>
                      ) : filteredEvents.length > 0 ? (
                        filteredEvents.map((event) => (
                          <div key={event.id} onClick={() => this.handleSelectEvent(event)} className="aad-search-item">
                            {event.banner && <img src={event.banner} alt="" className="aad-search-item-thumb" />}
                            <div className="aad-search-item-body">
                              <div className="aad-search-item-name">{event.name}</div>
                              <div className="aad-search-item-meta">
                                {[event.venue, event.start_month].filter(Boolean).join(" • ")}
                              </div>
                              {event.state && (
                                <span className={"aad-badge aad-badge--" + event.state.toLowerCase()}>{event.state}</span>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="aad-search-status">No events found for &ldquo;{searchQuery}&rdquo;</div>
                      )}
                    </div>
                  )}

                  {selectedEventData && (
                    <div className="aad-event-card">
                      {selectedEventData.banner && <img src={selectedEventData.banner} alt={selectedEventData.name} className="aad-event-card-banner" />}
                      <div className="aad-event-card-body">
                        <div className="aad-event-card-name">{selectedEventData.name}</div>
                        <div className="aad-event-card-rows">
                          <div className="aad-event-card-row">
                            <span className="aad-event-card-label"><IconMapPin /> Venue</span>
                            <span className="aad-event-card-value">{selectedEventData.venue || "—"}</span>
                          </div>
                          <div className="aad-event-card-row">
                            <span className="aad-event-card-label"><IconCalendar /> Date</span>
                            <span className="aad-event-card-value">{selectedEventData.start_month || selectedEventData.start_date || "—"}</span>
                          </div>
                          {selectedEventData.organizer && selectedEventData.organizer.length > 0 && (
                            <div className="aad-event-card-row">
                              <span className="aad-event-card-label"><IconUser /> Organizer</span>
                              <span className="aad-event-card-value">{selectedEventData.organizer.join(", ")}</span>
                            </div>
                          )}
                          {selectedEventData.state && (
                            <div className="aad-event-card-row">
                              <span className="aad-event-card-label"><IconTag /> Status</span>
                              <span className={"aad-badge aad-badge--" + selectedEventData.state.toLowerCase()}>{selectedEventData.state}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {activeTab === "location" && (
                <div className="aad-tab-panel">
                  <div className="aad-field" style={{ marginBottom: "16px" }}>
                    <label className="aad-label">City *</label>
                    <div className="aad-search-wrapper">
                      <span className="aad-search-icon">{citySearching ? <IconSpinner /> : <IconSearch />}</span>
                      <input
                        type="text"
                        className={"aad-input aad-input--search" + (selectedCity ? " aad-input--selected" : "")}
                        placeholder="Search by city name..."
                        value={cityQuery}
                        onChange={(e) => this.handleCitySearchChange(e.target.value)}
                        autoComplete="off"
                        readOnly={!!selectedCity}
                      />
                      {selectedCity && (
                        <button type="button" className="aad-search-clear" onClick={this.handleClearCity} title="Clear selection">✕</button>
                      )}
                    </div>

                    {showCityDropdown && (
                      <div className="aad-search-dropdown">
                        {citySearching ? (
                          <div className="aad-search-status">Searching...</div>
                        ) : filteredCities.length > 0 ? (
                          filteredCities.map((city) => (
                            <div key={"city-" + city.id} onClick={() => this.handleSelectCity(city)} className="aad-search-item">
                              <div className="aad-search-item-body">
                                <div className="aad-search-item-name">{city.name}</div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="aad-search-status">No cities found for &ldquo;{cityQuery}&rdquo;</div>
                        )}
                      </div>
                    )}

                    {selectedCityData && (
                      <div className="aad-event-card" style={{ marginTop: "10px" }}>
                        <div className="aad-event-card-body">
                          <div className="aad-event-card-name">{selectedCityData.name}</div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="aad-field">
                    <label className="aad-label">Venue (optional)</label>
                    <div className="aad-search-wrapper">
                      <span className="aad-search-icon">{venueSearching ? <IconSpinner /> : <IconSearch />}</span>
                      <input
                        type="text"
                        className={"aad-input aad-input--search" + (selectedVenue ? " aad-input--selected" : "")}
                        placeholder="Search by venue name..."
                        value={venueQuery}
                        onChange={(e) => this.handleVenueSearchChange(e.target.value)}
                        autoComplete="off"
                        readOnly={!!selectedVenue}
                      />
                      {selectedVenue && (
                        <button type="button" className="aad-search-clear" onClick={this.handleClearVenue} title="Clear selection">✕</button>
                      )}
                    </div>

                    {showVenueDropdown && (
                      <div className="aad-search-dropdown">
                        {venueSearching ? (
                          <div className="aad-search-status">Searching...</div>
                        ) : filteredVenues.length > 0 ? (
                          filteredVenues.map((venue) => (
                            <div key={"venue-" + venue.id} onClick={() => this.handleSelectVenue(venue)} className="aad-search-item">
                              <div className="aad-search-item-body">
                                <div className="aad-search-item-name">{venue.name}</div>
                                {venue.city && (
                                  <div className="aad-search-item-meta">
                                    {venue.area && <span><IconMapPinArea /> {venue.area} • </span>}
                                    <IconMapPinArea /> {venue.city}
                                  </div>
                                )}
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="aad-search-status">No venues found for &ldquo;{venueQuery}&rdquo;</div>
                        )}
                      </div>
                    )}

                    {selectedVenueData && (
                      <div className="aad-event-card" style={{ marginTop: "10px" }}>
                        <div className="aad-event-card-body">
                          <div className="aad-event-card-name">{selectedVenueData.name}</div>
                          <div className="aad-event-card-rows">
                            {selectedVenueData.area && (
                              <div className="aad-event-card-row">
                                <span className="aad-event-card-label"><IconMapPinArea /> Area</span>
                                <span className="aad-event-card-value">{selectedVenueData.area}</span>
                              </div>
                            )}
                            {selectedVenueData.city && (
                              <div className="aad-event-card-row">
                                <span className="aad-event-card-label"><IconMapPin /> City</span>
                                <span className="aad-event-card-value">{selectedVenueData.city}</span>
                              </div>
                            )}
                            {selectedVenueData.address && (
                              <div className="aad-event-card-row">
                                <span className="aad-event-card-label">Address</span>
                                <span className="aad-event-card-value">{selectedVenueData.address}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="aad-field" style={{ marginTop: "16px" }}>
                    <label className="aad-label">Event Date (optional)</label>
                    <input
                      type="date"
                      className="aad-input"
                      value={manualDate}
                      onChange={(e) => this.handleChange("manualDate", e.target.value)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="aad-actions">
            <Link to="/crud/gallery" className="aad-btn aad-btn--outline">Cancel</Link>
            <button
              type="button"
              className={"aad-btn aad-btn--primary" + (!this.isFormValid() ? " aad-btn--disabled" : "")}
              disabled={!this.isFormValid() || loading}
              onClick={this.handleContinue}
            >
              {loading ? "Creating..." : "Continue to Photos"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AddAlbumBasicDetails);


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/gallery/add/details/index.js